import type { FC } from 'react';

/**
 * Símbolo do Brik (o "k"), vetorizado a partir de icon.png.
 * Duas cores no tema claro; no escuro a Sidebar.css pinta as duas de branco.
 */
const BrikMark: FC<{ className?: string }> = ({ className }) => (
    <svg
        className={`brik-mark ${className ?? ''}`}
        viewBox="13.33 0 73.34 100"
        role="img"
        aria-label="Brik"
        focusable="false"
    >
        <path className="brik-mark-stem" d="M13.45 0L37.03 0.12L37.03 42.3L13.57 71.45Z" />
        <path className="brik-mark-stem" d="M28.61 65.64L37.03 76.54L37.03 100L13.45 100L13.33 84.12Z" />
        <path className="brik-mark-chevron" d="M57.88 29.15L82.29 29.15L57.88 60.43L86.67 99.88L59.66 99.88L33.12 60.07Z" />
    </svg>
);

export default BrikMark;
